import { render, staticRenderFns } from "./ProFeatureBadge.vue?vue&type=template&id=ee2c0820"
import script from "./ProFeatureBadge.vue?vue&type=script&lang=js"
export * from "./ProFeatureBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports